import {NgModule} from '@angular/core';
import {ArchiveClientOverviewComponent} from './archive-client-overview.component';
import {ArchiveEmployeeOverviewComponent} from './archive-employee-overview.component';
import {ArchiveComponent} from './archive.component';
import {SharedModule} from '../shared/shared.module';
import {DatagridModule} from '../datagrid/datagrid.module';

@NgModule({
  declarations: [
    ArchiveComponent,
    ArchiveClientOverviewComponent,
    ArchiveEmployeeOverviewComponent
  ],
  imports: [
    SharedModule,
    DatagridModule
  ],
})
export class ArchiveModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive.module.ts